import { AppState } from '../reducers';
import { MediaFile } from '../../typings/mediaFiles';

export const selectMediaFiles =
    (companyId: string) =>
    (state: AppState): MediaFile[] =>
        state.mediaFiles.files[companyId]
            ? state.mediaFiles.files[companyId]
            : [];
